// Сервис для отправки уведомлений
import { API_URL } from '../config';
import { safeFetch } from './safeFetch';

class NotificationService {
  // Отправка уведомления конкретному пользователю
  static async sendToUser(userId, title, message, type = 'info') {
    try {
      const response = await safeFetch(`${API_URL}/api/notifications`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user_id: userId,
          title,
          message,
          notification_type: type
        })
      });
      return response;
    } catch (error) {
      console.error('Ошибка отправки уведомления:', error);
      throw error;
    }
  }

  // Отправка уведомления всем пользователям
  static async sendToAll(title, message, type = 'info') {
    try {
      // Получаем список всех пользователей
      const users = await safeFetch(`${API_URL}/api/users`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      // Отправляем уведомление каждому пользователю
      const promises = users.map(user => 
        this.sendToUser(user.id, title, message, type)
      );
      
      // Ждем завершения всех отправок
      const results = await Promise.allSettled(promises);
      
      // Проверяем результаты
      const failed = results.filter(result => result.status === 'rejected');
      if (failed.length > 0) {
        console.warn(`Не удалось отправить ${failed.length} уведомлений`);
      }
      
      return results;
    } catch (error) {
      console.error('Ошибка отправки уведомлений всем пользователям:', error);
      throw error;
    }
  }

  // Отправка уведомления пользователям определенной роли
  static async sendToRole(role, title, message, type = 'info') {
    try {
      // Получаем список пользователей с указанной ролью
      const users = await safeFetch(`${API_URL}/api/users`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      // Фильтруем пользователей по роли
      const filteredUsers = users.filter(user => user.user_type === role);

      // Отправляем уведомление каждому пользователю
      const promises = filteredUsers.map(user => 
        this.sendToUser(user.id, title, message, type)
      );
      
      // Ждем завершения всех отправок
      const results = await Promise.allSettled(promises);
      
      // Проверяем результаты
      const failed = results.filter(result => result.status === 'rejected');
      if (failed.length > 0) {
        console.warn(`Не удалось отправить ${failed.length} уведомлений`);
      }
      
      return results;
    } catch (error) {
      console.error('Ошибка отправки уведомлений пользователям роли:', error);
      throw error;
    }
  }

  // Получение количества непрочитанных уведомлений
  static async getUnreadCount() {
    try {
      const data = await safeFetch(`${API_URL}/api/notifications/unread-count`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return data.count;
    } catch (error) {
      console.error('Ошибка получения количества непрочитанных уведомлений:', error);
      return 0;
    }
  }

  // Получение непрочитанных уведомлений
  static async getUnreadNotifications() {
    try {
      const data = await safeFetch(`${API_URL}/api/notifications/unread`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return data;
    } catch (error) {
      console.error('Ошибка получения непрочитанных уведомлений:', error);
      return [];
    }
  }

  // Отметить уведомление как прочитанное
  static async markAsRead(notificationId) {
    try {
      const response = await safeFetch(`${API_URL}/api/notifications/${notificationId}/read`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      return response;
    } catch (error) {
      console.error('Ошибка при отметке уведомления как прочитанного:', error);
      throw error;
    }
  }

  // Отметить все уведомления как прочитанные
  static async markAllAsRead() {
    try {
      const response = await safeFetch(`${API_URL}/api/notifications/read-all`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      return response;
    } catch (error) {
      console.error('Ошибка при отметке всех уведомлений как прочитанных:', error);
      throw error;
    }
  }
}

export default NotificationService;